import { useAttribute } from "lib/hooks";
import { forwardRef } from "react";

function Input({ style, onClick }, ref) {
  const [className] = useAttribute("className", false);
  return <input type="text" {...{ style, ref, className, onClick }} />;
}

export default forwardRef(Input);
